import { saveData } from "../modules/main/save-data";

export const saveDataOnActivation = (dataEntries, store) => {
  Object.entries(dataEntries).forEach(([key, value]) =>
    saveData({ data: [key, value], store })
  );
};
